import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/service/dialog-service';
import { ComponentBase } from 'src/app/base/component-base';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { UtilService } from 'src/app/service/util.service';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { ApplicantService } from 'src/app/service/applicant.service';
import { ToastrService } from 'ngx-toastr';
import { ISelectionBox } from 'src/app/model/ISelectionBox';

@Component({
  selector: 'app-list-work-experience',
  templateUrl: './list-work-experience.component.html',
  styleUrls: ['./list-work-experience.component.css']
})
export class ListWorkExperienceComponent extends ComponentBase implements OnInit {
  mainForm: FormGroup;
  title: string;
  maxiumNumberOfItems = 10;
  years: any[];
  months: any[];

  getLoadData() {

    this.utilService.getYears().subscribe(data => { this.years = data;
  });
    this.utilService.getMonths().subscribe(data => { this.months = data;

    });
  }
  constructor(private router: Router, private fb: FormBuilder, private utilService: UtilService
    ,         applicantService: ApplicantService, cookieLocal: CookiesLocalService, private toastr: ToastrService,
              behaviorModelChangeService: BehaviorModelChangeService, private dialogService: DialogService) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    console.log('list-work-exp-histroy');
    this.getLoadData();
    this.title = 'WORK EXPERIENCE';
    this.mainForm = this.fb.group({
      Caption: [''],
      ApplicantItems: this.fb.array([])
    });

    this.buildApplicantItems();

  }

  goToNext() {
    if (this.isPostgraduateStudent()) {
      this.router.navigate(['/applicant/info/post-certificate']);
    }
  }

  goToPrevious() {
    if (this.isPostgraduateStudent()) {
    this.router.navigate(['/applicant/info/post-high-school']);
    }
  }


  onAddItemClick(): void {
    const control = this.mainForm.controls.ApplicantItems as FormArray;
    const currentNumberOfExam = control.controls.length;

    if (currentNumberOfExam >= this.maxiumNumberOfItems) {
      this.toastr.warning(`Sorry you can only apply with (${this.maxiumNumberOfItems}) examinations`);
    } else {
    control.push(this.InitApplicantItems());
  }

  }

  buildApplicantItems() {

    const control = this.mainForm.controls.ApplicantItems as FormArray;
    this.applicantService.getApplicantWorkExperiencesByApplicantId(this.applicantData.ApplicationId)
    .subscribe(data => {
    //  console.log(data);
      data.forEach(item => {
       control.push(this.InitApplicantItems(item));
      });

    });
  }

  InitApplicantItems(data: any= null) {

    if (data) {
      const appCert = this.fb.group({
        ApplicationId: [this.applicantData.ApplicationId],
        ApplicantWorkExperienceId: [data.ApplicantWorkExperienceId],
        MonthOfEntry: [data.MonthOfEntry, Validators.required],
        YearOfEntry: [data.YearOfEntry, Validators.required],
        CompanyName: [data.CompanyName, Validators.required],
        CompanyAddress: [data.CompanyAddress, Validators.required],
        Position: [data.Position, Validators.required],
        YearOfCompletion: [data.YearOfCompletion, Validators.required],
        MonthOfCompletion: [data.MonthOfCompletion, Validators.required],

      });
      return appCert;
    }

    const appCert = this.fb.group({
      ApplicationId: [this.applicantData.ApplicationId],
      ApplicantWorkExperienceId: [0],
      MonthOfEntry: ['', Validators.required],
      YearOfEntry: ['', Validators.required],
      CompanyName: ['', Validators.required],
      CompanyAddress: ['', Validators.required],
      Position: ['', Validators.required],
      YearOfCompletion: ['', Validators.required],
      MonthOfCompletion: ['', Validators.required],

    });
    return appCert;
  }


  isFormValid() {
    const ctl = (this.mainForm.get('ApplicantItems') as FormArray);
    return this.mainForm.valid && ctl.length >= 0;
  }

  getApplicantItemsArray(form) {
    return   form.controls.ApplicantItems.controls;
  }

  // onSaveItemClick(item){
  //   console.log(item.value);
  //   this.applicantService.saveApplicantWorkExperience(item.value).subscribe(data=>{
  //     this.toastr.success('Work Experience saved successfully');
  //   },error=>{
  //     console.log(error);
  //   });
  // }

  onSaveItemClick(item, index) {

    this.applicantService.saveApplicantWorkExperience(item.value).subscribe(data => {
      (this.mainForm.get('ApplicantItems') as FormArray).at(index).value.ApplicantWorkExperienceId = data.Id;

      this.toastr.success('Work Experience saved successfully');
    }, error => {
      console.log(error);
    });

  }



  onRemoveItemClick(index) {
    const data = (this.mainForm.get('ApplicantItems') as FormArray).at(index).value;
    if (data.ApplicantWorkExperienceId > 0) {
      this.dialogService.openConfirmDialog('Are you sure you want this?').afterClosed().subscribe(() => {
        this.applicantService.removeApplicantWorkExperience(data.ApplicantWorkExperienceId).subscribe(() => {
            (this.mainForm.get('ApplicantItems') as FormArray).removeAt(index);
            this.toastr.success('Work Experience removed successfully');

        }, error => {
          console.log(error);
        });

      });

    } else {
      (this.mainForm.get('ApplicantItems') as FormArray).removeAt(index);

    }
  }
}
